import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Services from "@/pages/home/components/Services";
import Approach from "@/pages/home/components/Approach";
import Fields from "@/pages/home/components/Fields";
import Cases from "@/pages/home/components/Cases";
import Pricing from "@/pages/home/components/Pricing";
import Flow from "@/pages/home/components/Flow";
import FAQ from "@/pages/home/components/FAQ";
import Contact from "@/pages/home/components/Contact";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <Services />
      <Approach />
      <Fields />
      <Cases />
      <Pricing />
      <Flow />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}